import {
    Component,
    ContentChild,
    Directive,
    Inject,
    Input,
    PLATFORM_ID,
    TemplateRef,
} from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { NgIf, NgTemplateOutlet } from "@angular/common"

@Directive({ selector: "ng-template[heading]" })
export class HeadingTemplateDirective {
    constructor(public template: TemplateRef<unknown>) {}
}

@Directive({ selector: "ng-template[sub]" })
export class SubTemplateDirective {
    constructor(public template: TemplateRef<unknown>) {}
}

@Directive({ selector: "ng-template[eyebrow]" })
export class EyebrowTemplateDirective {
    constructor(public template: TemplateRef<unknown>) {}
}

@Component({
    selector: "hs-hero",
    imports: [NgIf, NgTemplateOutlet],
    templateUrl: "./hero.component.html",
    styleUrl: "./hero.component.scss",
})
export class HeroComponent {
    @Input() clipColor: string = "#f4f7fc"

    @ContentChild(HeadingTemplateDirective)
    headingTpl?: HeadingTemplateDirective

    @ContentChild(SubTemplateDirective)
    subTpl?: SubTemplateDirective

    @ContentChild(EyebrowTemplateDirective)
    eyebrowTpl?: EyebrowTemplateDirective

    constructor(
        @Inject(PLATFORM_ID) platformId: object,
        public router: Router,
        public route: ActivatedRoute
    ) {}
}
